import React, { CSSProperties, FC } from 'react';

const svgElementStyle: CSSProperties = {
  pointerEvents: 'none',
};

export const DragIconSvgEditor3: FC = () => (
  <svg style={svgElementStyle} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5 14.25C15.5 13.56 16.06 13 16.75 13C17.44 13 18 13.56 18 14.25C18 14.94 17.44 15.5 16.75 15.5C16.06 15.5 15.5 14.94 15.5 14.25ZM15.5 9.75C15.5 9.06 16.06 8.5 16.75 8.5C17.44 8.5 18 9.06 18 9.75C18 10.44 17.44 11 16.75 11C16.06 11 15.5 10.44 15.5 9.75ZM10.75 14.25C10.75 13.56 11.31 13 12 13C12.69 13 13.25 13.56 13.25 14.25C13.25 14.94 12.69 15.5 12 15.5C11.31 15.5 10.75 14.94 10.75 14.25ZM10.75 9.75C10.75 9.06 11.31 8.5 12 8.5C12.69 8.5 13.25 9.06 13.25 9.75C13.25 10.44 12.69 11 12 11C11.31 11 10.75 10.44 10.75 9.75ZM6 14.25C6 13.56 6.56 13 7.25 13C7.94 13 8.5 13.56 8.5 14.25C8.5 14.94 7.94 15.5 7.25 15.5C6.56 15.5 6 14.94 6 14.25ZM6 9.75C6 9.06 6.56 8.5 7.25 8.5C7.94 8.5 8.5 9.06 8.5 9.75C8.5 10.44 7.94 11 7.25 11C6.56 11 6 10.44 6 9.75Z"
      fill="#151414"
    />
  </svg>
);
